module.exports = __webpack_public_path__ + "media/3x/M-c44aa361.png";